import { Shader } from "@/components/feature/Shader";
import { FlipSection } from "@/pages/home/components/FlipSection";

export default function Home() {
  return (
    <div className="relative w-full bg-black text-white">
      {/* Fixed shader background */}
      <Shader />

      {/* Subtle dark overlay to keep text readable over the smoke */}
      <div className="pointer-events-none fixed inset-0 z-[1] bg-gradient-to-b from-black/40 via-black/10 to-black/50" />

      {/* Scrollable content overlaying the smoke */}
      <main className="relative z-10">
        <FlipSection>
          <p className="mb-4 text-xs md:text-sm uppercase tracking-[0.4em] text-white/70">
            Paper Design · Shaders
          </p>
          <h1 className="text-5xl md:text-7xl font-semibold tracking-tight drop-shadow-[0_2px_20px_rgba(0,0,0,0.6)]">
            Smoke Ring
          </h1>
          <p className="mt-6 max-w-xl mx-auto text-base md:text-lg text-white/80">
            Scroll to breathe life into the ring — it grows, spins, and swirls
            with you.
          </p>
          <div className="mt-10 flex items-center justify-center gap-2 text-white/60">
            <span className="text-xs uppercase tracking-widest">Scroll</span>
            <i className="ri-arrow-down-line text-lg" />
          </div>
        </FlipSection>

        <FlipSection>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight">
            Interactive by motion
          </h2>
          <p className="mt-6 text-base md:text-lg text-white/75">
            As you scroll, the ring expands outward, its inner void widens,
            and the noise intensifies — turning quiet smoke into a living
            storm.
          </p>
        </FlipSection>

        <FlipSection>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight">
            Keep going
          </h2>
          <p className="mt-6 text-base md:text-lg text-white/75">
            Every pixel is rendered live in the browser — no video, no
            images, just math and light.
          </p>
        </FlipSection>

        <FlipSection>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight">
            You reached the eye of the storm
          </h2>
          <p className="mt-6 text-base md:text-lg text-white/75">
            Scroll back up to watch it settle again.
          </p>
        </FlipSection>
      </main>
    </div>
  );
}